import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';

import RouterTabs from './RouterTabs';

export default compose(
  withRouter,
  withState('activeTab', 'setActiveTab', 'matches'),
  withHandlers({
    onClickTabItem: ({ baseName, router }) => (path) => {
      const newPath = `${baseName}/${path}`;
      router.push(newPath);
    },
  })
)(RouterTabs);
